"use client";

import { Feature, Section, Undercarriages, Tire } from "@/@types"
import { useState } from "react"
import UsedProductConditions from "./UsedProductConditions";

type Props = {
    features: Feature[],
    sections: Section[],
    undercarriages?: Undercarriages[],
    tires?: Tire[],
}

export default function UsedProductSpecs({ features, sections, undercarriages, tires }: Props) {
    const [activeTab, setActiveTab] = useState("especificaciones");

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
    }

    return (
        <div className="bg-white">
            <div className="container">
                <div className="mt-4 lg:mt-0 lg:pb-40 border-t pt-4">
                    <div className="grid grid-cols-2">
                        <button 
                            className={`py-2 px-4 text-lg font-bold ${
                                activeTab === "especificaciones" ? "text-black border-b-4 border-yellow-400" : "text-gray-800"
                            }`}
                            onClick={() => handleTabChange("especificaciones")}
                        >
                            ESPECIFICACIONES
                        </button>
                        <button 
                            className={`py-2 px-4 text-lg font-bold ${
                                activeTab === "condicion" ? "text-black border-b-4 border-yellow-400" : "text-gray-800"
                            }`}
                            onClick={() => handleTabChange("condicion")}
                        >
                            CONDICIÓN
                        </button>
                    </div>

                    <div className="mt-4">
                        {activeTab === "especificaciones" && features && features.length > 0 ? (
                            <ul className="grid grid-cols-2 gap-4 text-sm text-gray-600">
                                {features.map((feature, index) => (
                                    <li key={index} className="border-b uppercase pb-2">
                                        {feature.name}
                                    </li>
                                ))}
                            </ul>
                        ) : activeTab === "especificaciones" && (
                            <p className="font-bold">Sin información</p>
                        )}

                        {activeTab === "condicion" && sections && sections.length > 0 ? (
                            <UsedProductConditions 
                            sections={sections} 
                            undercarriages={undercarriages}
                            tires={tires}
                            />
                        ) : activeTab === "condicion" && (
                            <p className="font-bold">Sin información</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}